import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./addClass.css";

export default function AddSection() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const loadClasses = async () => {
    try {
      const res = await API.get("/school-admin/classes/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setClasses(res.data.classes || []);
    } catch (err) {
      console.error("Error loading classes", err);
    }
  };

  useEffect(() => { loadClasses(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!classId) return setMessage({ text: "Please select a class", type: "error" });
    if (!name.trim()) return setMessage({ text: "Enter section name", type: "error" });
    setLoading(true);
    try {
      await API.post("/school-admin/sections/add/",
        { class_id: classId, name },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      setMessage({ text: "Section added successfully!", type: "success" });
      setName(""); setClassId("");
      setTimeout(() => navigate("/school-admin/sections"), 900);
    } catch {
      setMessage({ text: "Error adding section", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ac-page">
        <div className="ac-card">

          <div className="ac-card-header">
            <span className="ac-card-icon">📋</span>
            <div>
              <h2 className="ac-card-title">Add New Section</h2>
              <p className="ac-card-sub">Create a section under a class (e.g. A, B, Rose)</p>
            </div>
          </div>

          {message.text && (
            <div className={`ac-alert ac-alert-${message.type}`}>{message.text}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="ac-form-group">
              <label className="ac-label">Select Class</label>
              <select
                className="ac-select"
                value={classId}
                onChange={(e) => setClassId(e.target.value)}
              >
                <option value="">-- Choose a Class --</option>
                {classes.map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            <div className="ac-form-group">
              <label className="ac-label">Section Name</label>
              <input
                type="text"
                className="ac-input"
                placeholder="e.g. A, B, Rose, Lily"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
            </div>

            <div className="ac-btn-row">
              <button type="button" className="ac-btn-back" onClick={() => navigate("/school-admin/sections")}>
                ← Back
              </button>
              <button type="submit" className="ac-btn-submit" disabled={loading}>
                {loading ? "Adding…" : "+ Add Section"}
              </button>
            </div>
          </form>

        </div>
      </div>
  );
}
